import request from '@/utils/request'

const url = 'admin/baseset.fodder'
/**
 * 饲草类型接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 添加Fodder
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 详情Fodder
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
     * 编辑Fodder
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 删除Fodder
     * @returns
     */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  }

}

export default api
